export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uložit"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pokud to vidíte, formulář nebyl získán (ale neměli byste to vidět)"])}
}